module.exports = __webpack_public_path__ + "static/img/gift_en.551b085f.png";